import React from 'react';
import { TicketPagingDto } from '@/__generated';
import { IFilterItem, IColumnType } from '@/components/ZTable';
import SellerInput from '@/components/FormItems/SellerInput';
import { formatApiDate, formatDisplayFullDate } from '@/config';

export const PAGE_TITLE = 'bookingPage_Title';

export const filters: Array<IFilterItem> = [
  { type: 'TEXT', name: 'BookingRefNo', label: 'ticketBooking_BookingRefNo' },
  { type: 'TEXT', name: 'ReceiptRefNo', label: 'bookingPage_ReceiptRefNo' },
  { type: 'TEXT', name: 'PassengerName', label: 'bookingPage_PassengerName' },
  { type: 'DATE', name: 'BookingDate', label: 'ticketBooking_BookingDate', parseValue: v => formatApiDate(v) },
  { type: 'DATE', name: 'departureDate', label: 'bookingPage_DepartureDate', parseValue: v => formatApiDate(v) },
  // Caisse et caissier (2026-11-02) : deux caissiers d'une même gare se distinguent.
  { type: 'SELECT', name: 'RegisterId', label: 'seller_Register', customElm: <SellerInput kind="register" /> },
  { type: 'SELECT', name: 'CashierId', label: 'seller_Cashier', customElm: <SellerInput kind="cashier" /> },
];

export const columns: IColumnType<TicketPagingDto>[] = [
  {
    title: 'ticketBooking_BookingRefNo',
    dataIndex: 'bookingRefNo',
    ellipsis: true,
    sorter: true,
    width: 150,
  },
  {
    title: 'ticketBooking_FromCity',
    dataIndex: 'sourceCityName',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'ticketBooking_ToCity',
    dataIndex: 'destinationCityName',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'tripsPage_TripName',
    dataIndex: 'tripNames',
    ellipsis: true,
    width: 150,
    render: v => v?.join(','),
  },
  {
    title: 'ticketBooking_Passenger',
    dataIndex: 'noOfPassengers',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'bookingPage_DepartureDate',
    dataIndex: 'departureDateTime',
    width: 170,
    ellipsis: true,
    render: v => (v ? formatDisplayFullDate(v) : ''),
    sorter: true,
  },
  {
    title: 'bookingPage_ArrivalDateTime',
    dataIndex: 'arrivalDateTime',
    width: 170,
    ellipsis: true,
    render: v => (v ? formatDisplayFullDate(v) : ''),
    sorter: true,
  },
  {
    title: 'bookingPage_TicketConditions',
    dataIndex: 'ticketConditions',
    ellipsis: true,
    width: 150,
    render: v => v?.join(','),
  },
  {
    title: 'bookingPage_TicketClasses',
    dataIndex: 'ticketClasses',
    width: 150,
    ellipsis: true,
    render: v => v?.join(','),
  },
  {
    title: 'seller_Register',
    dataIndex: 'registerName',
    ellipsis: true,
    width: 130,
  },
  {
    title: 'seller_Cashier',
    dataIndex: 'cashierName',
    width: 170,
  },
  {
    title: 'ticketBooking_BookingDate',
    dataIndex: 'bookingDate',
    width: 170,
    ellipsis: true,
    render: v => (v ? formatDisplayFullDate(v) : ''),
    sorter: true,
  },
];
